export default __webpack_public_path__ + "static/media/align_horizontal_right-B.1cd4a023.svg";